import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-file-modal',
    templateUrl: './file-modal.component.html',
    styleUrls: ['./file-modal.component.scss'],
    standalone: false
})
export class FileModalComponent {
  @Input() public data: any[];
}
